import CCatalogListPagination from "./CCatalogListPagination";
import TemplateLazyLoad from "./TemplateLazyLoad";
import JQuery from "jquery";
import BaseMCatalogTemplate from "./BaseMCatalogTemplate";
import BaseCCatalogListFilters from "./BaseCCatalogListFilters";

export default abstract class BaseCCatalogList {
  protected filtersController: BaseCCatalogListFilters;
  protected readonly paginationController: CCatalogListPagination;
  protected readonly _challengeTemplatesList: JQuery<HTMLElement>;
  private elementsOnPage: BaseMCatalogTemplate[];

  public constructor() {
    this._challengeTemplatesList = $(".challenge-template");

    new TemplateLazyLoad(".lazy-template-image");

    this._challengeTemplatesList.each((index, container) => {
      this._templates.push(this.createTemplate(container));
    });

    this._filteredTemplates = this._templates;
    this.elementsOnPage = this._templates;

    this.filtersController = this.createFilters();
    this.paginationController = new CCatalogListPagination(this);
  }

  protected abstract createTemplate(
    container: HTMLElement,
  ): BaseMCatalogTemplate;

  protected abstract createFilters(): BaseCCatalogListFilters;

  /**
   * Server-driven seam. The default (false) keeps the in-memory filtering/pagination used by the
   * Constellation catalog. The Troubadour catalog overrides these to fetch pages from the server;
   * the shared filters/pagination consult them instead of slicing the in-memory list.
   */
  public get isServerDriven(): boolean {
    return false;
  }

  // Total number of server pages for the current query (server-driven mode only).
  public serverPageCount: number = 1;

  // Load a server page (1-based). No-op for the in-memory catalog; overridden by Troubadour.
  public LoadServerPage(page: number): void {
    void page;
  }

  private _filteredTemplates: BaseMCatalogTemplate[] = [];

  public get filteredTemplates(): BaseMCatalogTemplate[] {
    return this._filteredTemplates;
  }

  public set filteredTemplates(value: BaseMCatalogTemplate[]) {
    this._filteredTemplates = value;
    if (this.paginationController) {
      this.paginationController.UpdateList();
    }
  }

  private _templates: BaseMCatalogTemplate[] = [];

  public get templates(): BaseMCatalogTemplate[] {
    return this._templates;
  }

  public UpdateElementsToDisplayOnPage(elements: BaseMCatalogTemplate[]): void {
    this.elementsOnPage = elements;
    this.templates.forEach((template) =>
      $(template.container).addClass("hide"),
    );
    this.elementsOnPage.forEach((template) =>
      $(template.container).removeClass("hide"),
    );
  }
}
